import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-rectangle",
  "use": "icon-rectangle-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-rectangle\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path class=\"cls-2\" d=\"M21,3.2a1,1,0,0,1,1,1v16a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V4.2a1,1,0,0,1,1-1ZM4,19.2H20V5.2H4Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol